<template>
  <div class="code">
    <div class="code__desc">
      <h3>Dziękujemy za rejestrację!</h3>
      <p>
        Na podany przy rejestracji adres e-mail została wysłana informacja o utworzeniu konta oraz
        kod potwierdzający rejestrację. Prosimy o wpisanie kodu poniżej
      </p>
    </div>
    <form class="code__form" @submit="handleSubmit">
      <div class="code__section">
        <div class="form__row code__row">
          <img src="@/assets/svg/lock.svg" alt />
          <input type="text" class="code__input" @blur="checkCode" v-model="code" placeholder="KOD" />
          <div v-if="error" class="form__row-error form__row-error--icon">{{error}}</div>
        </div>
        <div class="form__row code__row">
          <a @click="handleSubmit" :class="submitBtnClass">Aktywuj konto</a>
        </div>
      </div>
      <div class="code-actions">
        Jeśli wiadomość nie dotarła prosimy o kontakt z nami.
        <br />
        <router-link to="/kontakt" class="btn">Kontakt</router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "Code",
  data() {
    return {
      submitBtnClass: "btn",
      error: "",
      code: ""
    };
  },
  computed: mapGetters({
    registrationData: "getRegistrationData"
  }),
  methods: {
    checkCode() {
      this.error = "";
      !this.code ? (this.error = "Kod autoryzacyjny jest wymagany") : "";
    },
    handleSubmit(e) {
      e.preventDefault();

      this.checkCode();

      if (this.code && !this.error) {
        this.submitBtnClass = "btn spinner spinner--running";
        axios({
          method: "post",
          url: `${process.env.VUE_APP_API_URL}/register/activate`,
          data: {
            doctorId: this.registrationData.doctorId,
            code: this.code
          }
        })
          .then(() => {
            this.submitBtnClass = "btn spinner spinner--complete";
            setTimeout(() => this.$router.push("/zaloguj-sie"), 1000);
          })
          .catch(() => {
            this.error = "Wprowadzony kod jest nieprawidłowy";
            this.submitBtnClass = "btn";
          });
      }
    }
  }
};
</script>

<style lang="scss" >

</style>
